import React from 'react';

const ChapterNavigation = ({
  sections,
  filteredChapters,
  selectedIdx,
  setSelectedIdx,
  search,
  setSearch,
  openSections,
  setOpenSections,
  generatedChapterIds
}) => {
  // Safety check for openSections
  if (!openSections || !setOpenSections) {
    return (
      <div className="chapter-navigation">
        <div>Loading navigation...</div>
      </div>
    );
  }

  // Safety check for other required props
  if (!Array.isArray(sections) || !Array.isArray(filteredChapters)) {
    return (
      <div className="chapter-navigation">
        <div>Loading chapters...</div>
      </div>
    );
  }

  // Group chapters by section for display
  const getChaptersBySection = () => {
    const grouped = {};
    const noSectionChapters = [];
    if (Array.isArray(filteredChapters)) {
      filteredChapters.forEach(chapter => {
        if (chapter.sectionId) {
          if (!grouped[chapter.sectionId]) {
            grouped[chapter.sectionId] = [];
          }
          grouped[chapter.sectionId].push(chapter);
        } else {
          noSectionChapters.push(chapter);
        }
      });
    }
    return { grouped, noSectionChapters };
  };

  const { grouped, noSectionChapters } = getChaptersBySection();

  return (
    <div className="chapter-navigation">
      <input
        type="text"
        placeholder="Search chapters..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="search-input"
      />
      
      <div style={{ 
        width: '100%', 
        maxWidth: 600,
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '400px',
        scrollbarWidth: 'thin',
        scrollbarColor: '#888 #f1f1f1'
      }}>
        {Array.isArray(sections) && sections.map((section) => {
          const isOpen = !!openSections[section.id];
          return (
            <div key={section.id} className="section-group">
              <div
                className={`section-header ${isOpen ? 'open' : ''}`}
                onClick={() => setOpenSections(prev => ({ ...prev, [section.id]: !prev[section.id] }))}
              >
                <span style={{ marginRight: 8, transition: 'transform 0.2s', transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}>
                  <span className="material-icons">chevron_right</span>
                </span>
                {section.title}
              </div>
              {isOpen && (
                <>
                  {section.description && (
                    <p style={{ margin: '0 0 8px 0', fontSize: 14, color: '#666', padding: '0 12px' }}>
                      {section.description}
                    </p>
                  )}
                  <div className="chapter-buttons" style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '8px',
                    overflowX: 'auto',
                    overflowY: 'auto',
                    maxHeight: '200px',
                    paddingBottom: '8px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#888 #f1f1f1'
                  }}>
                    {Array.isArray(grouped[section.id]) && grouped[section.id]?.map((ch, idx) => {
                      const globalIdx = filteredChapters.findIndex(c => c.id === ch.id);
                      const isGenerated = generatedChapterIds && (generatedChapterIds.has(String(ch.id)) || generatedChapterIds.has(ch.id));
                      return (
                        <button
                          key={ch.id}
                          title={ch.title}
                          onClick={() => setSelectedIdx(globalIdx)}
                          className={`chapter-button ${globalIdx === selectedIdx ? 'selected' : ''} ${isGenerated ? 'generated' : ''}`}
                          style={{
                            minWidth: '150px',
                            flexShrink: 0,
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            lineHeight: '1.3'
                          }}
                        >
                          {ch.title}
                        </button>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
        })}
        
        {/* Other Chapters (no section) */}
        <div className="section-group">
          <div
            className={`section-header no-section ${openSections['no-section'] ? 'open' : ''}`}
            onClick={() => setOpenSections(prev => ({ ...prev, ['no-section']: !prev['no-section'] }))}
          >
            <span style={{ marginRight: 8, transition: 'transform 0.2s', transform: openSections['no-section'] ? 'rotate(90deg)' : 'rotate(0deg)' }}>
              <span className="material-icons">chevron_right</span>
            </span>
            Other Chapters
          </div>
          {openSections['no-section'] && (
            <div className="chapter-buttons" style={{
              display: 'flex',
              flexWrap: 'nowrap',
              gap: '8px',
              overflowX: 'auto',
              overflowY: 'auto',
              maxHeight: '200px',
              paddingBottom: '8px',
              scrollbarWidth: 'thin',
              scrollbarColor: '#888 #f1f1f1'
            }}>
              {Array.isArray(noSectionChapters) && noSectionChapters.map((ch, idx) => {
                const globalIdx = filteredChapters.findIndex(c => c.id === ch.id);
                const isGenerated = generatedChapterIds && (generatedChapterIds.has(String(ch.id)) || generatedChapterIds.has(ch.id));
                return (
                  <button
                    key={ch.id}
                    title={ch.title}
                    onClick={() => setSelectedIdx(globalIdx)}
                    className={`chapter-button ${globalIdx === selectedIdx ? 'selected' : ''} ${isGenerated ? 'generated' : ''}`}
                    style={{
                      minWidth: '150px',
                      flexShrink: 0,
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      lineHeight: '1.3'
                    }}
                  >
                    {ch.title}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChapterNavigation; 